'use strict';

require([
    'jquery',
    'interactive-survey',
    'off-canvas-menu',
    'slider',
    'scrollTo',
    'accordion',
    'subnavigation',
    'responsive-backgrounds',
    'animate-modules',
    'animate-news-overview-item',
    'share-article',
    'form-value-animation',
    'map',
    'open-login-modal',
    'counter-module-percentage',
    'counter-module-number',
    'quick-contact',
    'cookie',
    'search',
    'filters',
    'cvdbPageFilter',
    'foundation',
    'modernizr',
    'picturefill',
    'dropdown-language'
], function(
    $,
    interactiveSurvey,
    offCanvasMenu,
    slider,
    scrollTo,
    accordion,
    subNavigation,
    RespBgs,
    animateModules,
    animateNewsOverviewItem,
    shareArticle,
    formValueAnimation,
    map,
    OpenLoginModal,
    CounterModulePercentage,
    CounterModuleNumber,
    QuickContact,
    Cookie,
    Search,
    Filters,
    CvdbPageFilter,
    dropdownLanguage
) {

    $(function() {
        $(document).foundation();

        offCanvasMenu.init();
        slider.init();
        scrollTo.init();
        accordion.init();
        subNavigation.init();
        animateModules.init();
        animateNewsOverviewItem.init();
        shareArticle.init();
        formValueAnimation.init();
        map.init();
        OpenLoginModal.init();
        CounterModulePercentage.init();
        CounterModuleNumber.init();
        QuickContact.init();
        Cookie.init();
        Search.init();
        Filters.init();
        CvdbPageFilter.init();
        interactiveSurvey.init();
        dropdownLanguage;

        new RespBgs({
            global_holder_selector: '.hero',
            global_holder_equal_to_image_box: true
        });

    });

});
define("main", function(){});

